import React from "react";
import Loadable from "../../react-loadable";

const WeaCropper = Loadable({
  loader: () => import("./ImageCropper"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaCropper;



// WEBPACK FOOTER //
// ./ecology9/wea-image-cropper/index.js